import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAVideo, getVideos, resetState } from "../features/VideoSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Title",
    dataIndex: "title",
  },
  {
    title: "Video ID",
    dataIndex: "videos",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const VideosList = () => {
  const [open, setOpen] = useState(false);
  const [VideoId, setVideoId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setVideoId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getVideos());
  }, []);
  const getVideoState = useSelector((state) => state.Video.Videos);
  console.log(getVideoState);
  const data1 = [];
  for (let i = 0; i < getVideoState.length; i++) {
    data1.push({
      key: i + 1,
      title: getVideoState[i].title,
      videos:getVideoState[i].video,

      action: (
        <>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getVideoState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteAVideo(e)).then(() => {
      dispatch(getVideos());
    });
    setOpen(false);
  };
  return (
    <div>
      <h3 className="mb-4 title">Video List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(VideoId);
        }}
        title="Are you sure you want to delete this Video?"
      />
    </div>
  );
};

export default VideosList;
